//
// Copyright 2025 DXOS.org
//

export { SpaceId, ObjectId } from '@dxos/keys';
